import { render } from "./Search.vue?vue&type=template&id=d37506cc&scoped=true&bindings={}"
import script from "./Search.vue?vue&type=script&lang=ts"
export * from "./Search.vue?vue&type=script&lang=ts"

import "./Search.vue?vue&type=style&index=0&id=d37506cc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-d37506cc"

export default script